import { render, staticRenderFns } from "./CompletedTrips.vue?vue&type=template&id=a2176c68&"
import script from "./CompletedTrips.vue?vue&type=script&setup=true&lang=js&"
export * from "./CompletedTrips.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports